import { render, staticRenderFns } from "./codice.vue?vue&type=template&id=333b58ce"
import script from "./codice.vue?vue&type=script&lang=js"
export * from "./codice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports